import type { TFunction } from "i18next";
import type { InvitationOffer } from "../../../api/invitationsApi";
import { systemGroupName } from "../../access";

/**
 * What an invitation gives, in one plain line: by whom, the installation's Administrators for
 * an administrator, into which project, and the groups the person joins there, as the server
 * names them (one made before groups carried them names its role's starter group too; F133,
 * GS-7). The same words where it is listed and where it waits.
 */
export function offerLine(t: TFunction, offer: InvitationOffer): string {
  const parts = [
    offer.invitedBy === "" ? null : t("administration.invitations.by", { name: offer.invitedBy }),
    offer.accountRole === "administrator" ? t("administration.invitations.joins", { groups: systemGroupName(t, "administrators") }) : null,
    offer.projectName === null ? null : t("administration.invitations.into", { project: offer.projectName }),
    offer.groupNames.length === 0 ? null : t("administration.invitations.joins", { groups: offer.groupNames.join(", ") }),
  ];
  return parts.filter((part) => part !== null).join(" · ");
}
